class Constants {
    static API_URL = "http://localhost:5000";
    static LOGO_URL = "https://e-doltcini.com/img/doltcini-sportswear-logo-1448614562.jpg";
    static API_JWT = "lugrarnhzlkgqlnwruezlrfeulvjnjjzssiipyxwqgfovvfzpyrayodhlkxgdgrjvotvfxrjtoxusygwputhblbhgdgiwsbvxibz";
}
export default Constants;